import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import { Box } from '@mui/material'
import { useEffect, useRef, useState, memo } from 'react'
import { motion } from 'framer-motion'

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
)

const NetWorthGraph = ({ netWorth, demoMode = false }) => {
  const chartRef = useRef()

  // Adjust this to straight line until we have real data

  const demoData = [
    { date: 'Jan', value: 50 },
    { date: 'Feb', value: 55 },
    { date: 'Mar', value: 48 },
    { date: 'Apr', value: 62 },
    { date: 'May', value: 58 },
    { date: 'Jun', value: 65 },
    { date: 'Jul', value: 61 },
    { date: 'Aug', value: 70 },
    { date: 'Sep', value: 68 },
    { date: 'Oct', value: 72 },
    { date: 'Nov', value: 71 },
    { date: 'Dec', value: 75 },
  ]

  const realData = [
    { date: 'Jan', value: netWorth * 0.5 },
    // { date: 'Feb', value: netWorth * 0.6 },
    // { date: 'Mar', value: netWorth * 0.4 },
    // { date: 'Apr', value: netWorth * 0.4 },
    // { date: 'May', value: netWorth * 0.7 },
    // { date: 'Jun', value: netWorth * 0.4 },
    // { date: 'Jul', value: netWorth * 0.4 },
    // { date: 'Aug', value: netWorth * 0.7 },
    // { date: 'Sep', value: netWorth * 0.6 },
    // { date: 'Oct', value: netWorth * 0.8 },
    // { date: 'Nov', value: netWorth },
    { date: 'Dec', value: netWorth },
  ]

  const netWorthData = demoMode ? demoData : realData

  const labels = netWorthData.map((point) => point.date)
  const values = netWorthData.map((point) => point.value)

  const data = {
    labels,
    datasets: [
      {
        label: 'Net Worth',
        data: values,
        borderWidth: 6,
        borderColor: '#2370ED',
        backgroundColor: function (context) {
          const chart = context.chart
          const { ctx, chartArea } = chart

          if (!chartArea) return null

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          )
          // reverse the gradient if negative
          const hasNegative = context.dataset.data.some((v) => v < 0)

          if (hasNegative) {
            gradient.addColorStop(0, 'rgba(35, 112, 237, 0.0)')
            gradient.addColorStop(1, 'rgba(35, 112, 237, 0.3)')
          } else {
            gradient.addColorStop(0, 'rgba(35, 112, 237, 0.3)')
            gradient.addColorStop(1, 'rgba(35, 112, 237, 0.0)')
          }
          return gradient
        },
        tension: 0.5,
        pointRadius: 0,
        pointHoverRadius: 0,
        fill: true,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: () => (demoMode ? 'XX' : undefined), // undefined = default label
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
        ticks: {
          display: false,
          font: { size: 12 },
        },
      },
      y: {
        position: 'right',
        grid: { display: false, drawBorder: false },
        ticks: {
          callback: (val) => (demoMode ? 'XX' : `${val / 1000}k`),
          font: { size: 18 },
        },
      },
    },
    animations: {
      tension: {
        duration: 800,
        easing: 'easeInOutQuad',
        from: 0.5,
        to: 0.4,
        loop: false,
      },
      y: {
        duration: 1000,
        easing: 'easeOutQuart',
      },
    },
  }

  return (
    <motion.div
      style={{ height: 120, paddingTop: '16px', paddingBottom: '16px' }}
    >
      <Line ref={chartRef} data={data} options={options} />
    </motion.div>
  )
}
// Custom comparison function
const areEqual = (prevProps, nextProps) => {
  return prevProps.netWorth === nextProps.netWorth
}

export default memo(NetWorthGraph, areEqual)
